import { handleActions } from 'redux-actions';
import NotesType from '../types/NotesType';

const initialState = {
  noteDetails: {},
};

export const NoteDetails = handleActions(
  {
    [NotesType.actions.fetchNoteDetailsSuccess]: (currentState, { payload: noteDetails }) => {
      return {
        ...currentState,
        ...noteDetails,
      };
    },
  },
  initialState
);

export const getNoteDetails = (state) => {
  const { NoteDetails } = state;
  return NoteDetails.noteDetails;
};
